import slugify from 'standard-slugify';

export default (str = '') => slugify(str).replace(/-{2,}/g, '-');
